import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {ProductMedia, ProductPromotionalMaterial, ProductVideo} from "../../../models/product-media.model";
import {EnvironmentService} from "../../../../snatch/services";

@Component({
  selector: 'leap-media-card',
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaCardComponent implements OnInit {
  @Input() media: ProductPromotionalMaterial | ProductVideo;
  @Input() type: string;

    public showModalForVideo: ProductVideo = null;

    constructor(private env: EnvironmentService) { }

    ngOnInit() {
        // Update URL, because bucket is private, and we need to use sphinx instead.
        if (this.type === 'promotionalMaterials' && !this.media.url.includes('/proxy/phoenix2/jwt/')) {
            this.media = {
                ...this.media,
                url: this.env.sphinxUrl + '/proxy/phoenix2/jwt/' + this.media.url.substring(this.media.url.indexOf('/', 10))
            }
        }
    }

	closeModal() {
		this.showModalForVideo = null;
	}

	showVideoModal(media:ProductVideo) {
		this.showModalForVideo = media;
	}
}
